
import { createSlice } from "@reduxjs/toolkit";
import { IStudentEarlyAlertsSlice } from "../../../models/student/studentGrades";

const initialStudentEarlyAlertsState: IStudentEarlyAlertsSlice = {
    earlyAlerts: undefined,
  };
  
  const studentEarlyAlertsSlice = createSlice({
    name: "earlyAlerts",
    initialState: initialStudentEarlyAlertsState,
    reducers: {
      setStudentEarlyAlerts: (state, action: { payload: any }) => {
        state.earlyAlerts = action.payload;
      },
    },
  });
  
  export const { setStudentEarlyAlerts } = studentEarlyAlertsSlice.actions;
  
  const studentEarlyAlertsReducer = studentEarlyAlertsSlice.reducer;
  
  export type studentEarlyAlertsState = ReturnType<typeof studentEarlyAlertsReducer>;
  
  export default studentEarlyAlertsReducer;